import React from 'react';
import { LogOut } from 'lucide-react';

export default function QuickExitButton({ className = '' }) {
  const handleClick = () => {
    try {
      // Replace history so back button doesn't return to the site
      window.location.replace('https://www.bbc.co.uk/weather');
    } catch {
      window.location.href = 'https://www.bbc.co.uk/weather';
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Quickly exit this site"
      data-testid="quick-exit-button"
      className={`quick-exit tf-no-print inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[12px] font-bold ${className}`}
      style={{
        background: 'var(--tf-exit-bg)',
        color: 'var(--tf-text)',
        border: '1.5px solid var(--tf-exit-border)',
        letterSpacing: '0.04em',
      }}
    >
      <LogOut size={14} strokeWidth={2.2} />
      Exit Now
    </button>
  );
}
